import React from 'react'
import Navbar from '../components/Navbar';
import Cluster from './Cluster';

const User = () => {
  return (
    <div className="">
      <div className="flex flex-col-reverse relative">
        <div className="banner mentor_banner">
          {/* styling in index.css */}
          <img src="/images/user_page.jpg" alt="img" />
        </div>
        <div className="md:absolute top-[10%]  md:top-[30%] flex flex-col gap-5 items-center p-10 lg:px-40">
          <h3 className="text-3xl lg:text-5xl mx-auto md:w-[80%] text-center">
            Getting a job and having a career are two different things. We are
            strive here to build the latter for you!
          </h3>
          <div className='md:hidden flex flex-col gap-5 mt-10'>
            <a className="" href="/usersignup">
              <button className="text-xl">Create your free account!</button>
            </a>
            <a className="" href="/profilecluster">
              <button className="text-xl w-full">Create your Cluster!</button>
            </a>
          </div>
        </div>
      </div>
      <div className="m-5 md:m-24 md:mb-0 md:mt-4 flex p-10 flex-col md:flex-row-reverse rounded-[20px] gap-20 items-center ">
        <div className="md:w-[100%] md:mx-10">
          <h3 className="mb-10 md:mb-5 text-4xl lg:text-5xl">
            Connect with real life domain expert for free.
          </h3>
          <p className="py-5 text-xl md:w-[80%]">
            Ask them Technical questions . Do queries related to fresher jobs,
            internship, scholarships, interview, admission, industry, salary,
            profession and any topic related to your career.
          </p>
        </div>
        <div className="banner">
          {/*image CSS in index.css */}
          <img src="/images/user_page_banner.jpg" alt="banner" />
        </div>
      </div>
      <div className="m-5 md:m-24 md:mt-4 flex p-10 flex-col md:flex-row items-center rounded-[20px]">
        <div className="md:w-[100%] md:mx-10 ">
          <h3 className="mb-10 md:mb-5 text-4xl lg:text-5xl">Go for more!</h3>
          <p className="my-2 text-xl md:w-[80%]">
            Interact with domain expert via voice and video calls for more
            personalized learning.
          </p>
        </div>
        <div className="banner">
          {/*image CSS in index.css */}
          <img src="/images/user_page_banner2.jpg" alt="banner" />
        </div>
        <div className="">
          <a className="md:hidden block py-6" href="/usersignup">
            <button className="px-6">Create your free account!</button>
          </a>
        </div>
      </div>
      <div className="flex justify-center items-center gap-12">
        <a className="hidden md:block pb-10 pt-[-20px]" href="/usersignup">
          <button className="px-6">Create your free account!</button>
          {/* button CSS in index.css */}
        </a>
        <a className="hidden md:block pb-10 pt-[-20px]" href="/cluster">
          <button className="px-6">Create your cluster!</button>
          {/* button CSS in index.css */}
        </a>
      </div>
      {/* <Cluster/> */}
    </div>
  );
}

export default User